import { CLEAR_VIDEO_SCRIPT_TYPE, FETCH_GENERATED_VIDEO_SCRIPT, GET_VIDEO_SCRIPT_FAIL, GET_VIDEO_SCRIPT_REQUEST, GET_VIDEO_SCRIPT_SUCCESS, SET_SELECTED_VIDEO_SCRIPT_TYPE, SET_VIDEO_SCRIPT_TYPE } from "../constant";

const initialState = {
    data: [],
    videoScriptTypes: [
        { label: "Product Video", value: 0 },
        { label: "Demo Video", value: 1 },
        { label: "Case study Video", value: 2 },
        { label: "Use case Video", value: 3 },
    ],
    selectVideoScriptType: null,
    topic: "",
    generateScript: "",
    videoPrompt: "",
    commonKnowledge: "Select",
    assistant: "Select",
    prompt: "Select",
    videoScriptId: null,
    videoScriptDataLoading: false,
};

export const videoScriptReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_VIDEO_SCRIPT_TYPE:
            return {
                ...state,
                selectVideoScriptType: action.payload.selectVideoScriptType
            }

        case SET_SELECTED_VIDEO_SCRIPT_TYPE:
            return {
                ...state,
                topic: action.payload.topic,
                videoPrompt: action.payload.videoPrompt,
                commonKnowledge: action.payload.commonKnowledge,
                assistant: action.payload.assistant,
                prompt: action.payload.prompt,
            };

        case FETCH_GENERATED_VIDEO_SCRIPT:
            return {
                ...state,
                generateScript: action.payload.generateScript,
                videoScriptId: action.payload.videoScriptId,
            };

        case CLEAR_VIDEO_SCRIPT_TYPE:
            return {
                ...state,
                selectVideoScriptType: null,
                topic: "",
                videoPrompt: "",
                commonKnowledge: "Select",
                assistant: "Select",
                prompt: "Select",
                videoScriptId: null,
                generateScript: "",
                videoScriptDataLoading: false,
            }
        case GET_VIDEO_SCRIPT_REQUEST:
            return {
                ...state,
                videoScriptDataLoading: true,
            };
        case GET_VIDEO_SCRIPT_SUCCESS:
            return {
                ...state,
                videoScriptDataLoading: false,
                data: [...action.payload],
            };
        case GET_VIDEO_SCRIPT_FAIL:
            return {
                ...state,
                videoScriptDataLoading: false,
            };
        default:
            return state;
    }
};